"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.draggableModalReducer = exports.getModalState = exports.initialModalState = exports.initialModalsState = void 0;
var utils_1 = require("./utils");
var mapObject = function (o, f) {
    return Object.assign.apply(Object, __spreadArray([{}], Object.keys(o).map(function (k) {
        var _a;
        return (_a = {}, _a[k] = f(o[k]), _a);
    }), false));
};
exports.initialModalsState = {
    maxZIndex: 0,
    windowSize: (0, utils_1.getWindowSize)(),
    modals: {}
};
var initialModalState = function (height, width) {
    return {
        x: 0,
        y: 0,
        width: width ? width : 600,
        height: height ? height : 600,
        zIndex: 11,
        visible: false
    };
};
exports.initialModalState = initialModalState;
var getModalState = function (state, id, height, width) {
    return state.modals[id] || (0, exports.initialModalState)(height, width);
};
exports.getModalState = getModalState;
var getNextZIndex = function (state, id) {
    return (0, exports.getModalState)(state, id).zIndex === state.maxZIndex
        ? state.maxZIndex
        : state.maxZIndex + 1;
};
var clampDrag = function (windowWidth, windowHeight, x, y, width, height) {
    var maxX = windowWidth - width;
    var maxY = windowHeight - height;
    var clampedX = (0, utils_1.clamp)(0, maxX, x);
    var clampedY = (0, utils_1.clamp)(0, maxY, y);
    return { x: clampedX, y: clampedY };
};
var clampResize = function (windowWidth, windowHeight, x, y, width, height) {
    var maxWidth = windowWidth - x;
    var maxHeight = windowHeight - y;
    var clampedWidth = (0, utils_1.clamp)(0, maxWidth, width);
    var clampedHeight = (0, utils_1.clamp)(0, maxHeight, height);
    return { width: clampedWidth, height: clampedHeight };
};
var draggableModalReducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f;
    var windowSize = (0, utils_1.getWindowSize)();
    switch (action.type) {
        case 'resize': {
            var size = clampResize(windowSize.width, windowSize.height, action.x, action.y, action.width, action.height);
            return __assign(__assign({}, state), { maxZIndex: getNextZIndex(state, action.id), modals: __assign(__assign({}, state.modals), (_a = {}, _a[action.id] = __assign(__assign(__assign({}, state.modals[action.id]), size), { zIndex: getNextZIndex(state, action.id) }), _a)) });
        }
        case 'drag': {
            return __assign(__assign({}, state), { maxZIndex: getNextZIndex(state, action.id), modals: __assign(__assign({}, state.modals), (_b = {}, _b[action.id] = __assign(__assign(__assign({}, state.modals[action.id]), clampDrag(windowSize.width, windowSize.height, action.x, action.y, state.modals[action.id].width, state.modals[action.id].height)), { zIndex: getNextZIndex(state, action.id) }), _b)) });
        }
        case 'show': {
            var modalState = state.modals[action.id];
            var centerX = windowSize.width < 720 || windowSize.height < 420
                ? 0
                : (windowSize.width - modalState.width) / 2;
            var centerY = windowSize.width < 720 || windowSize.height < 420
                ? 0
                : (windowSize.height - modalState.height) / 2;
            var position = clampDrag(windowSize.width, windowSize.height, centerX, centerY, modalState.width, modalState.height);
            var size = clampResize(windowSize.width, windowSize.height, position.x, position.y, modalState.width, modalState.height);
            return __assign(__assign({}, state), { maxZIndex: state.maxZIndex + 1, modals: __assign(__assign({}, state.modals), (_c = {}, _c[action.id] = __assign(__assign(__assign(__assign({}, modalState), position), size), { zIndex: state.maxZIndex + 1, visible: true }), _c)) });
        }
        case 'focus': {
            var modalState = state.modals[action.id];
            return __assign(__assign({}, state), { maxZIndex: state.maxZIndex + 1, modals: __assign(__assign({}, state.modals), (_d = {}, _d[action.id] = __assign(__assign({}, modalState), { zIndex: state.maxZIndex + 1 }), _d)) });
        }
        case 'hide': {
            var modalState = state.modals[action.id];
            return __assign(__assign({}, state), { modals: __assign(__assign({}, state.modals), (_e = {}, _e[action.id] = __assign(__assign({}, modalState), { visible: false }), _e)) });
        }
        case 'mount': {
            var width = action.size.width ? action.size.width : 600;
            var height = action.size.height ? action.size.height : 600;
            var calculatedX = windowSize.width < 720 || windowSize.height < 420
                ? 0
                : (windowSize.width - width) / 2;
            var calculatedY = windowSize.width < 720 || windowSize.height < 420
                ? 0
                : (windowSize.height - height) / 2;
            return __assign(__assign({}, state), { maxZIndex: state.maxZIndex + 1, modals: __assign(__assign({}, state.modals), (_f = {}, _f[action.id] = {
                    width: width,
                    height: height,
                    visible: false,
                    x: calculatedX,
                    y: calculatedY,
                    zIndex: state.maxZIndex + 1
                }, _f)) });
        }
        case 'unmount': {
            var modalsClone = __assign({}, state.modals);
            delete modalsClone[action.id];
            return __assign(__assign({}, state), { modals: modalsClone });
        }
        case 'windowResize': {
            return __assign(__assign({}, state), { windowSize: windowSize, modals: mapObject(state.modals, function (modalState) {
                    var position = {
                        x: windowSize.width < 720 || windowSize.height < 420
                            ? 0
                            : (windowSize.width - modalState.width) / 2,
                        y: windowSize.width < 720 || windowSize.height < 420
                            ? 0
                            : (windowSize.height - modalState.height) / 2
                    };
                    var size = clampResize(windowSize.width, windowSize.height, position.x, position.y, modalState.width, modalState.height);
                    return __assign(__assign(__assign({}, modalState), position), size);
                }) });
        }
        default:
            throw new Error();
    }
};
exports.draggableModalReducer = draggableModalReducer;
